/*@flow*/
export const SET_RECORD = 'SET_RECORD';
export const PENDING = 'Pending';
export const FULFILLED = 'Fulfilled';
export const FAILURE = 'Failure';
export const COLORS = [
  '#7F3C8D',
  '#11A579',
  '#3969AC',
  '#F2B701',
  '#E73F74',
  '#80BA5A',
  '#E68310',
  '#008695',
  '#CF1C90',
  '#f97b72',
];
